export default __webpack_public_path__ + "static/media/contactMobile.37c465ff.jpeg";